import { useEffect, useRef } from 'react';
import type { HelpdeskAiContentKind } from '@shared/api';
import { useAiContentDeletion } from '../model/use-ai-content-deletion';
import { AiContentDeletionFeedback } from './AiContentDeletionFeedback';

export function AiContentListDeletion({
  scope,
  kind,
  id,
  title,
  canDelete,
  onClose,
  onStateChange,
}: {
  scope: string;
  kind: HelpdeskAiContentKind;
  id: string;
  title: string;
  canDelete: boolean;
  onClose: () => void;
  onStateChange?: (state: 'pending' | 'failed' | undefined) => void;
}) {
  const deletion = useAiContentDeletion({ scope, kind, id, canDelete, onDeleted: onClose });
  const { beginDelete, deletionState } = deletion;
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void beginDelete();
  }, [beginDelete]);
  useEffect(() => {
    onStateChange?.(deletionState);
  }, [deletionState, onStateChange]);
  return (
    <AiContentDeletionFeedback
      deletion={deletion}
      canDelete={canDelete}
      onClose={onClose}
      title={title}
    />
  );
}
